import { render, staticRenderFns } from "./rightBox.vue?vue&type=template&id=6356b11e&"
import script from "./rightBox.vue?vue&type=script&lang=js&"
export * from "./rightBox.vue?vue&type=script&lang=js&"
import style0 from "./rightBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports